module.exports = __webpack_public_path__ + "img/rnd3.e6c4e21e.jpg";